var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCameraOff = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 12.2001V6.91008C19 6.02008 17.92 5.57008 17.29 6.20008L15 8.50008V5.00008C15 4.45008 14.55 4.00008 14 4.00008H8.38998L17.3 12.9101C17.92 13.5401 19 13.0901 19 12.2001ZM0.70998 0.560078C0.31998 0.950078 0.31998 1.58008 0.70998 1.97008L2.72998 4.00008H1.99998C1.44998 4.00008 0.99998 4.45008 0.99998 5.00008V15.0001C0.99998 15.5501 1.44998 16.0001 1.99998 16.0001H14C14.21 16.0001 14.39 15.9201 14.55 15.8201L17.03 18.3001C17.42 18.6901 18.05 18.6901 18.44 18.3001C18.83 17.9101 18.83 17.2801 18.44 16.8901L2.11998 0.560078C1.72998 0.170078 1.09998 0.170078 0.70998 0.560078Z",
    fill: "black",
    fillOpacity: 0.6
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCameraOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/camera_off.0389d9502142e4a7c91b47990469ac55.svg";